import axios from "axios"

export default async function deleteDocument(projectName, formName, documentId){
    return await axios.delete(`/project/${projectName}/${formName}/document/${documentId}/delete`)
}
